
import { Gtp } from 'src/app/shared/gtp';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { ControlVelocidadService } from 'src/app/services/flota/control-velocidad-service/control-velocidad.service';
// import { Constant } from 'src/app/shared/constant';

import { MatDialog } from '@angular/material/dialog';
import { MapaPopUpComponent } from 'src/app/shared/mapa/mapa-popup/mapa-popup.component';

@Component({
  selector: 'app-movil-hoja-ruta',
  templateUrl: './movil-hoja-ruta.component.html',
  styleUrls: ['./movil-hoja-ruta.component.scss']
})
export class MovilHojaRutaComponent implements OnInit {

  @Input() mcodequipo: string;
  @Input() mdesde: string;
  @Input() mhasta: string;
  @Input() mvelocidad: string;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort; 
  pageEvent: PageEvent;
  expandedElement = null;

  public dataSource: MatTableDataSource<any>;
  public pageIndex: number = 0;
  public pageSize: number = 5;

  public filter: any = {
    desde : null,
    hasta : null,
    velocidad: 10,
    buscar: '',
    orderby: 'velocidad',
    sortby: 'desc',
    pageIndex: 0,
    pageSize: 5
  };
  public loading: boolean = false;  
  public tableCount;

  displayedColumns: string[] = [
    'color',
    'orden',
    'nombre',
    'latitud-entregado',
    'longitud-entregado',
    'llegada-real',
    'salida-real',
    'fhora-entrega-real',
    'retraso',
    'mts-al-punto',
    'observacion',
  ];

  constructor(
    private gtp: Gtp,
    private velocidad: ControlVelocidadService,
    public dialog: MatDialog
  ) {
    
  }

  ngOnInit() {
    this.filter.desde = this.mdesde;
    this.filter.hasta =this.mhasta;
    this.filter.velocidad =this.mvelocidad;
    this.dataSource = new MatTableDataSource();
    this.dataSource.paginator = this.paginator;
    this.loadInformeInterno();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  loadInformeInterno(){
    this.loading = true;
    this.velocidad.getControlVelocidadMovil(this.mcodequipo, this.filter).subscribe(res => {  
      this.loading = false;
      this.dataSource = new MatTableDataSource(res['list']);
      //this.dataSource = new MatTableDataSource( this.getDireccion(res['list']) );
      this.tableCount = res['count'];
      this.dataSource.sort = this.sort;
      //this.getTotalValores();
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  /**
   * Funcion para setear los valores de los filtros en la tabla para poderlos filtrar por eso datos.
   */
  setFitro() {
    // this.filter.fdesde = this.fechaHoraDesde;
    // this.filter.fhasta = this.fechaHoraHasta;
    // this.filter.velocidad = this.velocidad;
  }

  setSort(event?) {
    this.filter.orderby = event.active;
    this.filter.sortby = event.direction;
    this.loadInformeInterno();
  }

  setPagination(event?) {  
    this.filter.pageIndex = parseInt(event.pageIndex);
    this.filter.pageSize = parseInt(event.pageSize);
    this.loadInformeInterno();
    return event;
  }

  getPageSizeOptions(): number[] {    
    return [5, 10, 20, this.tableCount];
  }

  verMapa(latitud, longitud, rotacion){
    this.dialog.open(MapaPopUpComponent, {
      data: {
        latitud: latitud, 
        longitud: longitud,
        rotacion: parseFloat(rotacion)
      }
    });
  }

}
